module.exports = __webpack_public_path__ + "static/media/sheryl.653d1c67.jpg";